import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Output, EventEmitter, Pipe, PipeTransform, Renderer2, AfterViewInit, OnChanges, SimpleChanges, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';
import { CustomerService } from '../../../../../services/customer.service';
import { OrdersService } from '../../../../../services/orders.service';
import { InventoryService } from '../../../../../services/inventory.service';
import { EducationService } from '../../../../../services/education.service';
import { GlobalSearchService } from '../../../../../services/globalsearchservice.service';
import { DEFAULT_SALESMAN_ALLOWED } from '../../../../../classes/default-salesman-allowed';
import { GlobalsService } from '../../../../../services/globals.service';
import { UsersService } from '../../../../../services/users.service';
import { PurchasingService } from '../../../../../services/purchasing.service';
import { setModalZipMixMatchSidePanelOpen } from '../../../../modal-zip-layout.util';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import {
	PO_UPLOAD_ALLOWED_EXTENSIONS,
	PO_AVAILABLE_FIELD_TYPES,
	applyGreedyPoAutoMap,
	buildPoUploadLineInputs,
	getPoMatchOnMfgFromMappings,
	parsePoUploadSpreadsheet,
	poItemIdentificationHint,
	poUploadFieldTypeLabel,
	poUploadHasRequiredMappings,
	poUploadResolveItemIdentification,
	readFileAsArrayBuffer,
} from '../../po-upload-spreadsheet.util';

@Component({
	selector: 'app-beauty-wqoh',
	templateUrl: './beauty-wqoh.component.html',
	styleUrls: ['./beauty-wqoh.component.scss']
})
export class BeautyWqohComponent implements OnDestroy {
	@Input() customer: any = false;
	@Input() isdriver: any = false;
	@Input() type: any = '10';
	@Input() classreg: any = false;
	@Input() filtersOpen = false;
	@Input() filtered_items: any = [];

	@Output() addItem = new EventEmitter < any > ();
	@Output() addMix = new EventEmitter < any > ();
	@Output() addEduEvent = new EventEmitter < any > ();
	@Output() updateCart = new EventEmitter < any > ();
	@Output() flipToReview = new EventEmitter < any > ();
	@Output() handleEnter = new EventEmitter < any > ();

	itemSearchForm: UntypedFormGroup;
	regForm: UntypedFormGroup;
	eduReward: UntypedFormGroup;
	search_customer_items = new UntypedFormControl(false)
	search_vendor_items = new UntypedFormControl(false)
	edunotes = new UntypedFormControl('');
	filters: any = [];
	screenHeight: number;
	screenWidth: number;
	isInputFocused = false;

	limits = [
		{ name: '25', value: '25' },
		{ name: '50', value: '50' },
		{ name: '100', value: '100' },
		{ name: '200', value: '200' },
		{ name: '300', value: '300' },
		{ name: '500', value: '500' },
		{ name: 'No Limit', value: false },
	];

	sorts = [
		{ name: 'All Availability, Sell Low To High', value: 'avail.sell|ASC' },
		{ name: 'All Availability, Sell High To Low', value: 'avail.sell|DESC' },
		{ name: 'Local Availability, Sell Low To High', value: 'local.sell|ASC' },
		{ name: 'Local Availability, Sell High To Low', value: 'local.sell|DESC' },
		{ name: 'Sell Low To High', value: 'price|ASC' },
		{ name: 'Sell High To Low', value: 'price|DESC' },
		{ name: 'Name ASC', value: 'description|ASC' },
		{ name: 'Name DESC', value: 'description|DESC' },
		{ name: 'SKU ASC', value: 'stockid|ASC' },
		{ name: 'SKU DESC', value: 'stockid|DESC' },
	];

	showGuide = false;
	showfilters = false;
	searching = false;
	addingitems = false;
	inventorysearching: any = false;

	purchase_items: any = [];
	item_details: any = [];
	previous_search = '';
	salesman: any = false;
	//modal
	selecteditem: any = false
	itemhistory: any = false;
	editing_order: any = false;
	user: any = [];
	expanded_rows: any = [];
	promo: any = false;
	showorder = false;
	orderdetails: any = false;
	searched: any = false;
	po_upload_button: any = false;
	loyaltylist: any = [];
	
	editsallowed: any = {
		discounts: true,
		editar: true,
		editbilling: true,
		editshipping: true,
		editcontact: true,
		editprofile: true,
		editnotes: true,
		takepayment: true,
	}

	@ViewChild('purchasedetails') purchasedetails: ElementRef;
	@ViewChild('orderdetailsModal') orderdetailsModal: ElementRef;
	@ViewChild('itemHistoryRef') itemHistoryRef: ElementRef;
	@ViewChild('configproductele') configproductele: ElementRef;
	@ViewChild('nonstock') nonstockref: ElementRef;
	@ViewChild('mmmodal') mmodalref: ElementRef;
	@ViewChild('edumodal') eventmodalref: ElementRef;
	@ViewChild('uploadpo') uploadporef: ElementRef;
	@ViewChild('itemdetails') itemDetails: ElementRef;
	@ViewChild('itemsearch') itemsearchRef: ElementRef;
	@ViewChild('resultContainer') resultContainerRef: ElementRef;
	@ViewChild('firstItem') firstItem: ElementRef;
	@ViewChildren('firstQtyInput') firstQtyInputs: QueryList<ElementRef>;
	@ViewChildren('inputElement') inputElements: QueryList < ElementRef > ;
	@ViewChild('itemRowsScroll') itemRowsScroll: ElementRef<HTMLElement>;


	files: any = [];
	inputdata: any = false;

	poUploadColumns: string[] = ['stockid', 'description', 'manufacturer', 'line', 'vendor', 'min', 'max', 'qty', 'price'];
	uploaddata: any = false;
	processing_recs = false;
	poDataSource: any = false;
	poReviewReady = false;
	vendors_detected: any = false;
	uploadPodata: any = false;
	from_reorder = false;
	poHelp = false;

	upload_error: any = false;
	issalesman = false;
	poExcelWorkbook: XLSX.WorkBook | null = null;
	poSheetNames: string[] = [];
	poSelectedSheetName = '';
	poHeaderRowNumber = 1;
	poShowParseOptions = false;
	poActiveFile: File | null = null;
	poUploadedHeaders: string[] = [];
	poUploadedRawData: Record<string, string>[] = [];
	poColumnMappings: { [header: string]: string } = {};
	poUploadReady = false;
	poAvailableFieldTypes: string[] = [...PO_AVAILABLE_FIELD_TYPES];
	config: any = [];
	event: any = [];

	mmSubstituteRef = new UntypedFormControl('');
	mmSubstituteGroupRef = new UntypedFormControl();
	mm_items_selected: any = [];
	mmSidePanel = false;
	showSubstitution = false;
	substituteItem: any = false;
	substituteItemList = [];
	subsearch:any = false;
	allow_mm_substitutes = true;
	mm_progress: any = false;

	constructor(private educationService: EducationService, private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService, private renderer: Renderer2, private purchasingservice: PurchasingService) {

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.user = this.globalSearchService.user;
			

			this.globalSearchService.user.subscribe(u => {

				if (u.user.issalesman) {
					this.issalesman = true;
					this.showfilters = true;
					this.editsallowed = r.salesmanAllowed ?? DEFAULT_SALESMAN_ALLOWED
				}
			})
		});

		this.getScreenSize();
	}
	@HostListener('window:resize', ['$event'])

	ngOnInit(): void {

		if (this.type == '11') {
			this.search_customer_items.setValue(true);
		}

		if (this.type == '21') {
			this.search_vendor_items.setValue(false);
			this.po_upload_button = true;
		}

		if (this.user.value.user.salesman != '') {
			this.salesman = this.user.value.user.salesman;
		}

		switch (this.config.env.package) {
		case 'beauty':
			this.itemSearchForm = this.fb.group({
				keywords: ['', Validators.required],
				limit: [this.limits[3].value, Validators.required],
				sort: [this.sorts[8].value, Validators.required],
			});
			this.eduReward = new UntypedFormGroup({});
			this.educationService.getRewards().subscribe((r) => {
				const list = Array.isArray(r) ? r : [];
				this.loyaltylist = list;
				list.forEach((e) => {
					if (e?.type == '2' || e?.type === 2) {
						this.eduReward.addControl('additional-' + e.id, new UntypedFormControl('', []));
					}
					this.eduReward.addControl('amount-' + e.id, new UntypedFormControl('', []));
				});
			});
			break;
		default:
			this.itemSearchForm = this.fb.group({
				keywords: ['', Validators.required],
				limit: [this.limits[2].value, Validators.required],
				sort: [this.sorts[2].value, Validators.required],
			});

			if (this.isdriver) {
				this.itemSearchForm = this.fb.group({
					keywords: ['', Validators.required],
					limit: [this.limits[0].value, Validators.required],
					sort: [this.sorts[6].value, Validators.required],
				});
			}
			break;
		}

		this.mmSubstituteRef.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((newV) => {
			const data = {
				keywords: newV,
				limit: this.itemSearchForm.get('limit').value,
				sort: this.itemSearchForm.get('sort').value,
				customer: this.customer,
				filters: this.filters,
				customer_items_only: this.search_customer_items.value,
				vendor_items_only: this.search_vendor_items.value,
				type: this.type,
				user: this.user._value.user
			};

			if(newV.length){
				if(this.subsearch){
					this.subsearch.unsubscribe();
				}
				this.subsearch = this.orderService.getItemSearch(data).subscribe((items: any) => {
					this.subsearch = false;
					this.substituteItemList = items;
				});
			}
			
		})
	}

	setter(item, amt, add = false) {
		this.promo.intros.forEach(int => {
			if (int.mmid && int.mmid == item.introid) {
				int.items.forEach(prod => {
					if (prod.stockid == item.stockid && prod.quantity > 0) {
						if (!add) {
							prod.quantity = amt;
						} else {
							prod.quantity += amt;
						}
					}
				});
			}
		});
		if (amt == 0) {
			this.mm_items_selected.splice(this.mm_items_selected.indexOf(item), 1);
		}
		this.removeZeroSelections();
	}

	removeZeroSelections(){
		let index = 0;
		const rem = [];
		this.mm_items_selected.forEach(element => {
			if(element.quantity <= 0){
				rem.push(index);
			}
			index++;
		});

		rem.forEach(index => {
			this.mm_items_selected.splice(index, 1);
		});

		//on no items selected close the sidepanel
		if(!this.mm_items_selected.length){
			setModalZipMixMatchSidePanelOpen(false);
			this.mmSidePanel = false;
		}
	}

	searchPromos(event: any){
		let error: any = false;
		let audio;

		//input
		const input = event.target.value;
		event.target.value = '';
		const data = {
			barcode: input.toUpperCase()
		}

		//promos with items to select
		const to_search = this.promo.intros.filter((intro) => {
			if(intro['items']){
				return intro;
			}
		});
		
		this.inventoryService.absoluteItemSearch(data).subscribe((res) => {
			//possible intros for crossover
			const possibleIntros = [];

			if(res.length == 1){
				const looking_for = res[0].stockid;
				to_search.forEach(intro => {
					intro['items'].forEach(prod => {
						if(prod.stockid.toUpperCase() == looking_for.toUpperCase()){
							possibleIntros.push({
								intro: intro,
								prod: prod
							})
						}
					});
				});
				//attempt to add to each promo
				if(possibleIntros.length){
					let success = false;
					possibleIntros.forEach(attempt => {
						if(!success){
							if(this.updateMMQty(attempt.intro) > 0){
								//if match not found and intro still avail
								if(this.incrementmm(attempt.prod, attempt.intro) ){
									error = false;				
									success = true;
									audio = new Audio('/assets/pristine-609.mp3');		
								}
							}else{
								error = 'Promo Requirements Filled';
							}
						}
					});
				}else{
					error = 'Scanned item doesn\'t belong to this promo';
				}
			}else{
				error = 'Multiple items tied to barcode';
			}
			
			if(error){
				audio = new Audio('/assets/money.mp3');
				this.globalSearchService.showNotification(error, 'danger', 'bottom', 'right')			
			}

			audio.play();
		})
	}
	
	isCompleted(promo: any): boolean {
		let disablebutton = false;
		(promo.intros).forEach(intro => {
			if(intro.mmid){
				if(!disablebutton){
					disablebutton = this.updateMMQty(intro) > 0 ? true : false;
				}
			}
		});
		return disablebutton;
	}

	getMMQtyUsed(mm: any): number {
		const items = mm.items || [];
		if (mm.dsptype == '$') {
			return items.reduce((a: number, item: any) => a + parseFloat(item.quantity) * parseFloat(item.price), 0);
		}
		return items.reduce((a: number, item: any) => a + parseFloat(item.quantity), 0);
	}

	isIntroMixMatchSatisfied(intro: any): boolean {
		if (!intro?.mmid) {
			return false;
		}
		return !intro.error && this.financial(this.updateMMQty(intro)) === 0;
	}

	isPromoMixMatchComplete(promo: any): boolean {
		if (!promo?.intros?.length) {
			return false;
		}
		let anyGroup = false;
		for (const intro of promo.intros) {
			if (!intro.mmid) {
				continue;
			}
			anyGroup = true;
			if (!this.isIntroMixMatchSatisfied(intro)) {
				return false;
			}
		}
		return anyGroup;
	}

	/**
	 * Effective collapsed state for a mix & match group.
	 * Default is expanded. Users can manually collapse via the header click;
	 * that preference is stored on `intro._userCollapsed`. A single group never
	 * collapses.
	 */
	isGroupCollapsed(intro: any, intros: any[]): boolean {
		if (!intro || intro.type === '1' || intro.type === 1) {
			return false;
		}
		const groupCount = this.getNumberOfNonType1Intros(intros || []);
		if (groupCount <= 1) {
			return false;
		}
		return intro._userCollapsed === true;
	}

	toggleGroup(intro: any, intros: any[], event?: Event): void {
		if (event) {
			event.stopPropagation();
		}
		if (!intro) { return; }
		const currentlyCollapsed = this.isGroupCollapsed(intro, intros);
		intro._userCollapsed = !currentlyCollapsed;
	}

	/** True when the group has no selectable items — flags missing product_to_mms data. */
	isGroupEmpty(intro: any): boolean {
		if (!intro || intro.type === '1' || intro.type === 1) {
			return false;
		}
		const items = intro.filteredItems ? intro.filteredItems : intro.items;
		return !items || items.length === 0;
	}

	customerAllowedInvoice() {
		let allowed = true;
		if (this.customer.dissallowinvoices && this.customer.dissallowinvoices != '0' && this.config.arhold == true) {
			allowed = false;
		}
		return allowed;
	}

	getScreenSize(event ? ) {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
	}

	showPurchases(stockidid: any) {

	}

	runFunction(newvalue: any) {
		this.itemSearchForm.get('keywords').setValue(newvalue);
		this.itemSearch();
	}

	addNonStock(event: any) {
		const item = event;
		const data = { item: item, debtorno: this.customer.debtorno, branchcode: this.customer.branchcode }


		this.orderService.addNonStock(data).subscribe((results: any) => {
			this.updateCart.emit(results);
			this.globalSearchService.showNotification(item.description + ' x ' + item.qty + ' Added', 'success', 'bottom', 'right');
		});
	}

	triggerMm(item: any) {
		const data = {
			stockid: item.stockid,
			qty: item.quantity,
			loccode : this.user._value.user.defaultlocation.loccode
		}

		this.inventoryService.getPromo(data).subscribe(r => {
			this.promo = r;
			this.promo.itemdesc = item;
			this.promo.qty = r.qty
			this.modalService.open(this.mmodalref, { ariaLabelledBy: 'modal-title', size: 'zip', animation: false }).result.then((result: any) => {

			}, (reason) => {
				this.promo = false;
				this.selecteditem = false;
				this.mm_items_selected = [];
				this.mmSidePanel = false;
			});
		})
	}

	triggerEdu(item: any) {
		const data = {
			stockid: item.stockid,
		}

		this.educationService.getEventByStockId(data).subscribe(r => {
			this.event = r;
			this.regForm = this.fb.group({
				eduname: ['', Validators.required],
				educell: ['', Validators.required],
				eduemail: ['', Validators.required],
				eduinsta: [''],
			});
			this.edunotes.setValue('');
			const list = Array.isArray(this.loyaltylist) ? this.loyaltylist : [];
			list.forEach((e) => {
				if (e?.type == '2' || e?.type === 2) {
					const addCtrl = this.eduReward.get('additional-' + e.id);
					if (addCtrl) {addCtrl.setValue('');}
				}
				const amtCtrl = this.eduReward.get('amount-' + e.id);
				if (amtCtrl) {amtCtrl.setValue('');}
			});
			this.modalService.open(this.eventmodalref, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false, backdrop: 'static', keyboard:false }).result.then((result: any) => {

			}, (reason) => {
				this.event = false;
			});
		})
	}
	addSeat() {


		const s = { name: this.regForm.get('eduname').value, cell: this.regForm.get('educell').value, email: this.regForm.get('eduemail').value, insta: this.regForm.get('eduinsta').value };
		if (this.regForm.valid) {
			this.event.seats.push(s);
			this.regForm = this.fb.group({
				eduname: ['', Validators.required],
				educell: ['', Validators.required],
				eduemail: ['', Validators.required],
				eduinsta: [''],
			});
		}
		const seatcount = this.event.seats.length;
		this.event.total = this.financial(seatcount * parseFloat(this.event.discount));

	}

	remSeat(seat: any) {
		const index = this.event.seats.indexOf(seat);
		if (index >= 0) {
			this.event.seats.splice(index, 1);
		}
		const seatcount = this.event.seats.length;
		this.event.total = this.financial(seatcount * parseFloat(this.event.discount));
	}
	addedureg() {
		//test kit first
		this.event.loyalty = this.eduReward.value;
		this.event.notes = this.edunotes.value;
		this.addEduEvent.emit(this.event);
		this.modalService.dismissAll();
	}
	itemSearch() {

		const keywords = this.itemSearchForm.get('keywords').value;

		let proceed = false;

		if (!this.filters.length && keywords == '') {
			proceed = false;
		} else {
			if (this.filters.length || keywords != '') {
				proceed = true;
			}
		}

		if (proceed) {

			this.globalSearchService.hideSideBar();
			this.searching = true;
			this.addingitems = true;

			this.filtered_items = [];

			if (this.inventorysearching) {
				this.inventorysearching.unsubscribe()
			}

			const data = {
				keywords: keywords,
				limit: this.itemSearchForm.get('limit').value,
				sort: this.itemSearchForm.get('sort').value,
				customer: this.customer,
				filters: this.filters,
				customer_items_only: this.search_customer_items.value,
				vendor_items_only: this.search_vendor_items.value,
				type: this.type,
				user: this.user._value.user
			};


			this.inventorysearching = this.orderService.getItemSearch(data).subscribe((items: any) => {
				this.filtered_items = items
				this.searched = true;
				this.searching = false;
				if (items.length) {
					if (!this.showfilters) {
						// this.itemSearchForm.get('keywords').setValue('');
					}
				}
				if (this.itemsearchRef) {
					this.globalSearchService.blurInputElement(this.itemsearchRef);
				}


			});
		} else {
			this.searching = false;
		}
	}

	scrollToAndFocusInput(): void {
		//this.itemsearchRef.nativeElement.scrollIntoView({ behavior: 'auto', block: 'start' });

		setTimeout(() => {
		 // window.scrollBy(0, -50);
		  this.itemsearchRef.nativeElement.focus();
		}, 100);
	}

	expand_row(index) {
		this.expanded_rows.includes(index) ? this.expanded_rows.splice(this.expanded_rows.indexOf(index), 1) : this.expanded_rows.push(index);
	}

	isExpanded(index) {
		return this.expanded_rows.includes(index);
	}


	getLineTotal(item: any): number {
		let qty = item.quantity
		if (!qty || item.quantity == 0) {
			qty = 1;
		}

		if (this.config.env.package == 'beauty') {
			var value = this.financial(qty) * (this.financial(item.price) - this.financial(this.getItemDiscountMultiplier(item) * item.price))
		} else {
			//removed discount - handled on php side in $this->shop->getAlternateCustPrice
			var value = (this.financial(qty) * (this.financial(item.price)) + this.financial(item.fetvalue))
		}

		return value;

	}

	getQohPillClass(qoh: number): string {
		const n = qoh != null ? Number(qoh) : 0;
		if (n <= 0) return 'qoh-pill--red';
		if (n < 4) return 'qoh-pill--yellow';
		return 'qoh-pill--green';
	}

	getAvailPillClass(item: { quantity?: number; locqoh?: number; qos?: number }): string {
		const avail = (item.locqoh != null ? item.locqoh : 0) - (item.qos != null ? item.qos : 0);
		const qty = Number(item.quantity) || 0;
		return qty > avail ? 'avail-pill--red' : '';
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}

	updateFilters(event: any) {
		this.filters = event;
		this.itemSearch();
	}

	updateFilteredItems(event: any) {
		this.searching = true;
	}

	updateItem(data: any) {
		const itemdata = this.filtered_items.filter((item: any) => {
			return data.item.stockid == item.stockid
		})[0]

		const index = this.filtered_items.indexOf(itemdata);
		this.filtered_items[index] = itemdata;
	}

	addPromo(item: any) {
		const data = {
			stockid: item.stockid,
			qty: item.quantity,
			loccode: this.user.defaultlocation
		}

		this.inventoryService.getPromo(data).subscribe(r => {
			this.promo = r;
			this.promo.itemdesc = item;
			this.promo.qty = r.qty
			this.addMM(this.promo);
		})
	}

	getNumberOfNonType1Intros(intros): number {
		let count = 0;
		for (const intro of intros) {
			if (intro.type !== '1' && intro.type !== 1) {
				count++;
			}
		}
		return count > 0 ? count : 1;
	}

	addMM(intro: any) {
		//test kit first
		this.addMix.emit(intro);
		this.modalService.dismissAll();
	}

	setParent(event: any, parent: any) {
		parent.qty = event.target.value;
		//multiply base values by current
		parent.intros.forEach((intro: any) => {
			intro.floor = intro.original_floor
			intro.floor = intro.floor * parent.qty;
			this.updateMMQty(intro);
		})

	}

	updateMMQty(mm: any) {
		mm.error = true;
		const items = mm.items || [];
		let child = false;
		if(mm['dsptype'] == '$'){
			var used = items.reduce((accumulator, item) => accumulator + (parseFloat(item.quantity)* parseFloat(item.price)) , 0);
			child = true;
		}else{
			var used = items.reduce((accumulator, item) => accumulator + parseFloat(item.quantity), 0);
		}

		const floorValue = this.financial(mm.floor);
		const remainingValue = floorValue - this.financial(used);

		if(!child){
			if (remainingValue < 0) {
				mm.error = true;
				let overage = -remainingValue; // Make the overage positive

				for (let i = items.length - 1; i >= 0; i--) {
					const item = items[i];
					const itemQuantity = parseFloat(item.quantity);

					if (itemQuantity > 0) {
						if (itemQuantity >= overage) {
							item.quantity = Math.max(0, Math.floor((itemQuantity - overage) * 100) / 100); // Ensure two decimal places
							overage = 0;
							break;
						} else {
							item.quantity = 0;
							overage -= itemQuantity;
						}
					}
				}

				this.globalSearchService.showNotification('Error, Total Qty Adjusted: Items Quantities Reduced', 'danger', 'bottom', 'right');
			} else {
				mm.error = remainingValue !== 0;
			}
		}

		if(!child){
			return Math.max(0, remainingValue);
		}else{
			return remainingValue;
		}
	}

	decrementmm(item: any, intro: any) {
		if (item.quantity > 0) {
			item.quantity -= 1;
			this.updateMMQty(intro);
			this.update_selections(item, intro.mmid);
		}
	}

	incrementmm(item: any, intro: any, showError = true) {
		if (this.updateMMQty(intro) > 0 || intro['dsptype'] == '$') {
			item.quantity += 1;
			this.updateMMQty(intro);
			this.update_selections(item, intro.mmid);
			return true;
		} else {
			if(showError){
				this.globalSearchService.showNotification('Promo Requirements Filled', 'danger', 'bottom', 'right')
			}
			return false;
		}
	}

	qtyMM(event: any, item: any, intro: any) {
		item.quantity = 0;
		const original_qty = item.quantity;
		let qty_used = this.financial(event.target.value);
		const test_qty = parseFloat(original_qty) + parseFloat(event.target.value);
		const maxqty = this.updateMMQty(intro);

		if (test_qty > maxqty) {
			qty_used = maxqty;
			this.globalSearchService.showNotification('Maximum of ' + qty_used + ' Allowed', 'danger', 'bottom', 'right')
		}

		if(isNaN(qty_used)){
			event.target.value = 0;
			qty_used = 0;
		}else{
			event.target.value = qty_used;
		}

		item.quantity = qty_used
		this.updateMMQty(intro);
		this.update_selections(item, intro.mmid);
	}

	getSub(introName){
		//need to update the selected promo
		let found = false;
		let index = 0 ;
		this.promo.intros.forEach(int => {
			if(int.name == introName){
				found = true;
			}
			if(!found){
				index++;
			}
		});

		this.substituteItem.quantity = 1;
		this.substituteItem.substitute = true;		
		this.substituteItem.qoh.quantity = this.substituteItem.qoh.filter((i) => i.loccode == this.user._value.user.defaultlocation.loccode)[0].quantity;
		this.promo.intros[index].items = [this.substituteItem, ...this.promo.intros[index].items];
		this.updateMMQty(this.substituteItem);
		this.update_selections(this.substituteItem, this.promo.intros[index].mmid);

		this.showSubstitution = false;
		this.substituteItem = false;
		this.substituteItemList = [];
		this.mmSubstituteGroupRef.setValue('');
		this.mmSubstituteRef.setValue('');	
	}

	mmprogress(){
		let total_floor = 0;
		let added = 0;
		this.promo.intros.forEach(i => {
			if(i.mmid){
				total_floor += i.floor;
				added += this.updateMMQty(i);
			}
		});
		added = total_floor - added;
		const percent = (added / total_floor) * 100;
		const ret = {
			percent: percent,
			added: added,
			total: total_floor,
			complete: percent >= 100
		}

		return ret;
	}

	update_selections(item,introid){
		this.mm_progress = this.mmprogress();
		item.introid = introid;

		let update = false
		const empty = !this.mm_items_selected.length;
		const itempresent = this.mm_items_selected.find((i) => i.stockid == item.stockid) ?? false;


		(empty || !itempresent) ? this.mm_items_selected.push(item) : update = true; 
		

		//on first item selected open side panel
		if(!update && this.mm_items_selected.length > 0){
			setModalZipMixMatchSidePanelOpen(true);
			this.mmSidePanel = true;
		}


		if(update){
			let index = 0
			let found = false
			this.mm_items_selected.forEach(prod => {
				if(prod.stockid == item.stockid){
					found = true;
				}else if(!found){
					index++;
				}
			});

			if(found){
				if(item.quantity > 0){
					this.mm_items_selected[index] = item;
				}
			}
		}
		this.removeZeroSelections();
	} 

	decrement(item: any) {
		const index = this.filtered_items.indexOf(item);
		const quantity = Number(this.filtered_items[index].quantity);

		if (!isNaN(quantity)) {
			if (this.config.env.package == 'tires') {
				if (quantity > 0) {
					this.filtered_items[index].quantity = quantity - 1;
				}
			} else { // allowing negatives
				this.filtered_items[index].quantity = quantity - 1;
			}
		}
	}

	increment(item: any) {
		const index = this.filtered_items.indexOf(item);
		const quantity = Number(this.filtered_items[index].quantity);

		if (!isNaN(quantity)) {
			this.filtered_items[index].quantity = quantity + 1;
		}
	}

	updateSearchPrice(event: any, item: any) {
		const index = this.filtered_items.indexOf(item);
		const val = this.financial(event.target.value);
		if (!isNaN(val)) {
			this.filtered_items[index].price = val;
		}
	}

	updateSearchQuantity(event: any, item: any) {
		const index = this.filtered_items.indexOf(item);
		this.filtered_items[index].quantity = event.target.value;
	}

	getItemDiscountMultiplier(item) {
		if (!isNaN(this.financial(item.discount))) {
			return this.financial(item.discount / 100);
		}
		return 0;
	}

	getEffectivePrice(item: any): number {
		const list = this.financial(item.price);
		const mult = 1 - this.getItemDiscountMultiplier(item);
		return this.financial(list * mult);
	}

	getDiscountTaken(item: any): number {
		const list = this.financial(item.price);
		return this.financial(list * this.getItemDiscountMultiplier(item));
	}

	updateSearchDiscount(event: any, item: any) {
		const index = this.filtered_items.indexOf(item);

		if (!isNaN(this.financial(event.target.value))) {
			this.filtered_items[index].discount = this.financial(event.target.value);
			if (this.filtered_items[index].discount != 0) {
				this.filtered_items[index].hasdiscount = true;
			} else {
				this.filtered_items[index].hasdiscount = false;
			}
		}
	}


	addToOrder(item: any) {

		const copyOfItems = Object.assign([], this.filtered_items);
		let this_index = '';

		this_index = this.filtered_items.indexOf(item)
		if (!copyOfItems[this_index].quantity) {
			copyOfItems[this_index].quantity = 1;
		}


		const allow = true;

		if (this.isdriver) {
			if (copyOfItems[this_index].quantity > copyOfItems[this_index].max_credit) {
				alert('Maximum Qty Credit ' + copyOfItems[this_index].max_credit + ' for ' + copyOfItems[this_index].stockid + ' Reached, call main office.');
				copyOfItems[this_index].quantity = 0;
				return false;
			}
		}

		const add_items = [];

		copyOfItems.forEach((items: any, index) => {
			items.allownegative = true;
			items.isnegative = false;

			if (this.type == '21') {

				const qty_request = parseFloat(items.quantity);
				if (qty_request != 0) {
					const qty_min = parseFloat(items.minorderqty);
					const qty_max = parseFloat(items.maxorderqty);

					const qty_max_stock = parseFloat(item.minmax.maximum);
					const qty_min_stock = parseFloat(item.minmax.minimum);

					if (qty_min > 0 && qty_max > 0) {
						if (qty_request > qty_max) {
							// allow = confirm('Attempting to Purchase more than '+qty_max+' for '+items.description+', procced?');
						}

						if (qty_request < qty_min) {
							// allow = confirm('Attempting to Purchase less than '+qty_min+' for '+items.description+', procced?');
						}
					}

					if (allow) {
						if (qty_max_stock > 0 && qty_max_stock > 0) {
							if (qty_request > qty_max_stock) {
								// allow = confirm('Attempting to Purchase more than '+qty_max_stock+' for '+items.description+', procced?');
							}

							if (qty_request < qty_min_stock) {
								// allow = confirm('Attempting to Purchase less than '+qty_min_stock+' for '+items.description+', procced?');
							}
						}
					}
				}
			}
			if (allow) {
				if (parseFloat(items.quantity) != 0) {
					add_items.push(items);
				}
			}

		});

		this.addItem.emit(add_items);
		this.filtered_items.forEach(i => { i.quantity = 0; });

	}

	addMultipleToOrder() {
		this.filtered_items.forEach(element => {
			element.quantity > 0 ? this.addToOrder(element) : '';
		});
	}

	setPurchOrderOptions(cart_id: any, selected: any) {
		const data = { cart_id: cart_id, options: selected }
		this.orderService.setPoOptions(data).subscribe((results: any) => {
			this.modalService.dismissAll();
			this.purchase_items = [];
		});

		this.updateCart.emit(true);
	}


	//modals
	viewitemOrderHistory(item: any) {
		this.selecteditem = item;
		this.customerService.getCustomerHistoryItem(this.customer.debtorno, item.stockid).subscribe((result: any) => {
			this.itemhistory = result
			this.inventoryService.getPurchaseHistory(item.stockid).subscribe(async (result: any) => {
				this.itemhistory.purchase = result;
			})

			this.modalService.open(this.itemHistoryRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result: any) => {

			}, (reason) => {
				this.itemhistory = [];
				this.selecteditem = false;
			});
		});
	}

	viewPurchOrderOptions(line: any) {
		line.allownegative = true;
		const data = { cart_id: line.cart_id, stockid: line.stockid }
		this.orderService.getPurchDataFromLine(data).subscribe((results: any) => {
			this.purchase_items.push(results);
			this.modalService.open(this.purchasedetails, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result: any) => {

			}, (reason) => {
				this.purchase_items = [];
			});
		});
	}

	loadOrder(order) {
		this.orderService.getOrderInqSearch(order).subscribe((results: any) => {
			this.showorder = true;
			this.orderdetails = results[0];


			this.modalService.open(this.orderdetailsModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {

			}, (reason) => {

			});

		});
	}

	openModal(content, item) {

		this.item_details = item;
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.item_details = false;
		});
	}

	toggleFilters() {
		this.showfilters = (this.showfilters) ? false : true;

		if (!this.showfilters) {
			this.filters = [];
			this.itemSearch();
		}

	}

	toggleGuide() {
		this.showGuide = (this.showGuide) ? false : true;
	}

	open_po_upload() {
		this.modalService.open(this.uploadporef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.uploadPodata = [];
			this.files = [];
			this.resetUploadPo()
			this.upload_error = false;
		});
	}

	poUploadFieldLabel(type: string): string {
		return poUploadFieldTypeLabel(type, this.config?.env?.package === 'tires');
	}

	get poItemMappingBanner(): { type: 'error' | 'hint'; text: string } | null {
		if (!this.poUploadReady) {
			return null;
		}
		const id = poUploadResolveItemIdentification(this.poColumnMappings);
		if (id.ok === false) {
			return { type: 'error', text: id.error };
		}
		const hint = poItemIdentificationHint(this.poColumnMappings);
		return hint ? { type: 'hint', text: hint } : null;
	}

	uploadPo() {
		if (!poUploadHasRequiredMappings(this.poColumnMappings)) {
			this.globalSearchService.showNotification(
				'Map item identification (internal ID or manufacturer part) and order quantity.',
				'warning',
				'bottom',
				'right'
			);
			return;
		}
		const id = poUploadResolveItemIdentification(this.poColumnMappings);
		if (id.ok === false) {
			this.globalSearchService.showNotification(id.error, 'warning', 'bottom', 'right');
			return;
		}
		const { items: lineInputs, skippedRows } = buildPoUploadLineInputs(this.poUploadedRawData, this.poColumnMappings);
		if (skippedRows > 0) {
			this.globalSearchService.showNotification(
				`${skippedRows} row(s) skipped — Brand is mapped but those rows have an empty brand or part.`,
				'info',
				'bottom',
				'right'
			);
		}
		if (!lineInputs.length) {
			this.globalSearchService.showNotification(
				'No order lines found (check quantities and mapped item / brand + part values).',
				'warning',
				'bottom',
				'right'
			);
			return;
		}

		this.uploadPodata = {
			items: [],
			lines: { good: 0, bad: 0 },
			units: { good: 0, bad: 0 }
		};

		this.upload_error = false;
		this.processing_recs = true;

		const vendors: string[] = [];
		lineInputs.forEach((li) => {
			if (li.vendor) {
				vendors.push(li.vendor);
			}
		});

		const data = {
			items: lineInputs,
			matchOnMfg: getPoMatchOnMfgFromMappings(this.poColumnMappings)
		};
		this.purchasingservice.buildPoFromUpload(data).subscribe({
			next: (res) => {
				this.poDataSource = {};

				if (res['good']) {
					this.poDataSource['good'] = new MatTableDataSource(res['good'].sort((a, b) => a.quantity.localeCompare(b.quantity)).reverse());
					res['good'].map((i) => {
						this.uploadPodata['lines']['good']++;
						this.uploadPodata['units']['good'] += Number(i.quantity);
					});
					this.uploadPodata['items'] = res['good'];
				}

				if (res['bad']) {
					this.poDataSource['bad'] = new MatTableDataSource(res['bad'].sort((a, b) => a.quantity.localeCompare(b.quantity)).reverse());
					res['bad'].map((i) => {
						this.uploadPodata['lines']['bad']++;
						this.uploadPodata['units']['bad'] += Number(i.quantity);
					});
				}

				this.vendors_detected = Array.from(new Set(vendors.filter((i) => { return i !== undefined && i !== ''; }))).join(',');

				if (this.vendors_detected != '') {
					this.from_reorder = true;
				} else {
					this.from_reorder = false;
				}
				this.poReviewReady = true;
				this.processing_recs = false;
			},
			error: () => {
				this.processing_recs = false;
				this.globalSearchService.showNotification('Could not match lines to inventory.', 'danger', 'bottom', 'right');
			},
		});
	}

	buildPO() {
		if (this.vendors_detected != this.customer.supplierid && this.from_reorder) {
			if (confirm('Vendor selected does not match vendors from upload, continue?')) {
				this.addItem.emit(this.uploadPodata['items'])
				this.files = [];
				this.resetUploadPo();
				this.modalService.dismissAll();
				this.flipToReview.emit();
			}
		} else {
			this.addItem.emit(this.uploadPodata['items']);
			this.files = [];
			this.resetUploadPo();
			this.modalService.dismissAll();
			this.flipToReview.emit();
		}
	}

	clearPoSpreadsheetParseState(): void {
		this.poUploadedRawData = [];
		this.poUploadedHeaders = [];
		this.poColumnMappings = {};
		this.poUploadReady = false;
	}

	clearPoSpreadsheetAll(): void {
		this.files = [];
		this.poActiveFile = null;
		this.poExcelWorkbook = null;
		this.poSheetNames = [];
		this.poSelectedSheetName = '';
		this.poHeaderRowNumber = 1;
		this.poShowParseOptions = false;
		this.clearPoSpreadsheetParseState();
		this.upload_error = false;
	}

	resetPoReviewResults(): void {
		this.poReviewReady = false;
		this.processing_recs = false;
		this.vendors_detected = false;
		this.poDataSource = false;
	}

	resetUploadPo() {
		this.resetPoReviewResults();
		this.clearPoSpreadsheetAll();
	}

	toggleUploadHelp() {
		this.poHelp = this.poHelp == true ? false : true;
	}

	onPoDropzoneChange(event: NgxDropzoneChangeEvent): void {
		if (!event) {
			return;
		}
		if (event.rejectedFiles?.length) {
			const names = event.rejectedFiles.map((f) => f.name).join(', ');
			this.globalSearchService.showNotification(
				`Not added (type or size): ${names}`,
				'warning',
				'bottom',
				'right'
			);
		}
		if (!event.addedFiles?.length) {
			return;
		}
		const f = event.addedFiles[0];
		const lower = f.name.toLowerCase();
		if (!PO_UPLOAD_ALLOWED_EXTENSIONS.some((ext) => lower.endsWith(ext))) {
			this.globalSearchService.showNotification(
				`Use CSV or Excel only: ${f.name}`,
				'warning',
				'bottom',
				'right'
			);
			return;
		}
		if (event.addedFiles.length > 1) {
			this.globalSearchService.showNotification(
				'Only one file at a time — using the first file.',
				'info',
				'bottom',
				'right'
			);
		}

		this.clearPoSpreadsheetParseState();
		this.poActiveFile = f;
		this.files = [f];
		this.poShowParseOptions = true;
		this.poHeaderRowNumber = 1;
		this.upload_error = false;

		if (lower.endsWith('.xlsx') || lower.endsWith('.xls')) {
			this.processing_recs = true;
			readFileAsArrayBuffer(f)
				.then((buf) => {
					try {
						this.poExcelWorkbook = XLSX.read(buf, { type: 'array', cellDates: true, dense: false });
						this.poSheetNames = [...(this.poExcelWorkbook.SheetNames || [])];
						this.poSelectedSheetName = this.poSheetNames[0] || '';
					} catch {
						this.globalSearchService.showNotification(
							'Could not read that Excel file.',
							'danger',
							'bottom',
							'right'
						);
						this.clearPoSpreadsheetAll();
					}
					this.processing_recs = false;
					this.cdr.markForCheck();
				})
				.catch(() => {
					this.processing_recs = false;
					this.globalSearchService.showNotification('Could not read file.', 'danger', 'bottom', 'right');
					this.clearPoSpreadsheetAll();
					this.cdr.markForCheck();
				});
		} else {
			this.poExcelWorkbook = null;
			this.poSheetNames = [];
			this.poSelectedSheetName = '';
			this.processing_recs = false;
		}
	}

	onRemove(event: File): void {
		this.files = this.files.filter((x) => x !== event);
		if (!this.files.length) {
			this.clearPoSpreadsheetAll();
		} else {
			this.upload_error = false;
		}
	}

	parsePoSpreadsheetForPoModal(): void {
		if (!this.poActiveFile) {
			this.globalSearchService.showNotification('Add a file first.', 'info', 'bottom', 'right');
			return;
		}
		const lower = this.poActiveFile.name.toLowerCase();
		if ((lower.endsWith('.xlsx') || lower.endsWith('.xls')) && !this.poSelectedSheetName) {
			this.globalSearchService.showNotification('Pick a sheet to import.', 'warning', 'bottom', 'right');
			return;
		}

		this.processing_recs = true;
		this.clearPoSpreadsheetParseState();

		void parsePoUploadSpreadsheet({
			file: this.poActiveFile,
			workbook: this.poExcelWorkbook,
			selectedSheetName: this.poSelectedSheetName,
			headerRowNumber: this.poHeaderRowNumber,
		}).then((res) => {
			if ('error' in res) {
				const msg =
					res.error === 'reload_excel'
						? 'Reload the Excel file.'
						: res.error === 'sheet_not_found'
							? 'That sheet was not found in the workbook.'
							: res.error === 'csv_empty'
								? 'CSV appears empty.'
								: res.error === 'bad_extension'
									? 'Unsupported file type.'
									: 'Could not parse file.';
				this.globalSearchService.showNotification(msg, res.error === 'parse_failed' ? 'danger' : 'warning', 'bottom', 'right');
				this.processing_recs = false;
				this.cdr.markForCheck();
				return;
			}

			this.poUploadedRawData = res.rows;
			this.poUploadedHeaders = res.rows.length > 0 ? Object.keys(res.rows[0]) : [];
			this.poUploadedHeaders.forEach((h) => {
				if (this.poColumnMappings[h] === undefined) {
					this.poColumnMappings[h] = 'ignore';
				}
			});
			applyGreedyPoAutoMap(this.poUploadedHeaders, this.poColumnMappings, this.poAvailableFieldTypes);
			this.poUploadReady = res.rows.length > 0;
			if (!res.rows.length) {
				this.globalSearchService.showNotification(
					'No data rows after the header row. Try a higher header row # if titles are not on row 1.',
					'warning',
					'bottom',
					'right'
				);
			}
			this.processing_recs = false;
			this.cdr.markForCheck();
		});
	}

	handleMouseDown(event: MouseEvent) {
		// Blur the input field to remove focus
		event.stopPropagation();
		this.itemsearchRef.nativeElement.blur();
	}

	cleanAndFormatHTML(htmlContent: string): string {
		if (!htmlContent) {
			return '';
		}
		// Clean up the HTML content
		const cleanedHTML = htmlContent
			// Remove excessive white spaces
			.replace(/\s{2,}/g, ' ')
			// Remove extra line breaks
			.replace(/\n\s*\n/g, '\n')
			// Trim leading and trailing white spaces
			.trim();

		// Format the HTML content nicely
		let formattedHTML = '';
		const parser = new DOMParser();
		const doc = parser.parseFromString(cleanedHTML, 'text/html');
		if (doc.body) {
			formattedHTML = doc.body.innerHTML;
		}

		return formattedHTML;
	}

	filterItems(intro) {
		if (intro.searchQuery) {
			intro.filteredItems = this.globalSearchService.filterItem(intro.items, intro.searchQuery, 'stockid,description,barcode,lineid')
		} else {
			intro.filteredItems = [...intro.items];
		}
	}

	onInputFocus() {
		this.isInputFocused = true;
	}

	onInputBlur() {
		this.isInputFocused = false;
	}

	trackByStockId(index: number, item: any): string {
		return item.stockid;
	}

	ngAfterViewInit() {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.filtered_items) {
			requestAnimationFrame(() => {
				const el = this.itemRowsScroll?.nativeElement;
				if (el) {
					el.scrollTop = 0;
				}
			});
		}
		if (changes.filtered_items && changes.filtered_items.currentValue.length) {
			this.focusFirstItem();
		}
		if(changes.classreg){
			if(this.classreg && this.classreg != null){
				this.triggerEdu(this.classreg);
			}
		}
	};

	handleTabKey(event: KeyboardEvent, index: number) {
		const inputsArray = this.inputElements.toArray();
		if (event.key === 'Tab' && !event.shiftKey) {
			if (index === inputsArray.length - 1) {
				event.preventDefault();
				const input = this.getVisibleFirstQtyInput();
				if (input) input.focus();
			}
		}
	}

	handleEnterKey(event: KeyboardEvent, index: number) {
		if (event.key === 'Enter') {
			event.preventDefault();
			this.handleEnter.emit(event);
		}
	}

	handleEnterInput(item: any, index: number, event: any ) {
		if (item.ispromo && !item.ispromo.requiresconfig) {
			this.addPromo(item);
		} else {
			this.addToOrder(item);
		}
		this.handleEnterKey(event, index);
	}


	private focusFirstItem() {
		setTimeout(() => {
			const input = this.getVisibleFirstQtyInput();
			if (input) {
				input.focus();
				setTimeout(() => input.select(), 0);
			}
		}, 50);
	}

	private getVisibleFirstQtyInput(): HTMLInputElement | null {
		if (this.firstQtyInputs?.length) {
			for (const el of this.firstQtyInputs.toArray()) {
				const input = el?.nativeElement as HTMLInputElement;
				if (input && input.offsetParent !== null) return input;
			}
		}
		return this.firstItem?.nativeElement as HTMLInputElement || null;
	}

	selectText(event: FocusEvent) {
		const input = event.target as HTMLInputElement;
		if (input) {
			setTimeout(() => {
				input.select();
			}, 0);
		}
	}

	ngOnDestroy(): void {
	}
}
